import apiClient, { extractData } from "../api-client";

// Gửi in sang CMS in theo từng danh sách in (backend/app/api/cmsin.py).
// Không phải printJobApi — đó là hàng đợi in phiếu của xưởng.
export const cmsinApi = {
  list(orderId) {
    return apiClient.get(`/orders/${orderId}/cmsin`).then(extractData);
  },
  send(orderId, printKey) {
    return apiClient.post(`/orders/${orderId}/cmsin/${encodeURIComponent(printKey)}/send`).then(extractData);
  },
  // action: confirm | cancel | refresh
  action(orderId, jobId, action) {
    return apiClient.post(`/orders/${orderId}/cmsin/jobs/${jobId}/${action}`).then(extractData);
  },
  // Popup kiểm preview: toạ độ khung tên/số + layout (proxy GET /review của CMS in).
  review(orderId, jobId) {
    return apiClient.get(`/orders/${orderId}/cmsin/jobs/${jobId}/review`).then(extractData);
  },
  // body { rows: [{row, name?, number?, size?}], layouts: {SIZE: {name?, number?}}, note? }
  revise(orderId, jobId, body) {
    return apiClient.post(`/orders/${orderId}/cmsin/jobs/${jobId}/revise`, body).then(extractData);
  },
  // Tick / bỏ tick "Đã kiểm preview"; revision = bản ảnh đang nhìn (lệch ⇒ 409).
  check(orderId, jobId, rows, checked, revision) {
    return apiClient.post(`/orders/${orderId}/cmsin/jobs/${jobId}/check`, { rows, checked, revision }).then(extractData);
  },
};
